"use strict";
function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;
//# sourceMappingURL=_baseHasIn.js.map